import { Report } from '../types';

export const getHasEvaluationColumn = (report: Report) => {
  return (
    report?.evaluation &&
    Boolean(Object.values(report?.evaluation)?.some?.((evaluation) => Boolean(evaluation?.name)))
  );
};
